import React from 'react'
import {
  SmartWidget,
  useSmartWidgetContextValue,
  Text,
  Flex,
  Chip,
} from '@workwhile/ui'
import { Sparkles } from 'lucide-react'
import { useShiftDetailContextValue } from 'pages/Shifts/ShiftDetail/context/ShiftDetailProvider'

export const RootScreen = () => {
  const { push } = useSmartWidgetContextValue()
  const {
    state: {
      company: { name: companyName },
    },
  } = useShiftDetailContextValue()
  return (
    <>
      <SmartWidget.Group.Title Icon={Sparkles}>
        WorkWhile Intelligence
      </SmartWidget.Group.Title>
      <Text mt={2} color="lightText">
        Need help with this shift at {companyName}? WorkWhile Intelligence is
        here to help - starting with small things that make a big difference.
        More tools coming your way soon.
      </Text>
      <Flex mt={3}>
        <Chip
          variant="outline"
          size="large"
          onClick={() => push('shift-analysis')}
        >
          Analyze this shift
        </Chip>
      </Flex>
    </>
  )
}
